module.exports = __webpack_public_path__ + "static/media/NovotelSipcot04.01c6e133.jpg";